import { render, staticRenderFns } from "./TableDetails.vue?vue&type=template&id=15084be6&scoped=true&"
import script from "./TableDetails.vue?vue&type=script&lang=js&"
export * from "./TableDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableDetails.vue?vue&type=style&index=0&id=15084be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15084be6",
  null
  
)

export default component.exports